module.exports = __webpack_public_path__ + "media/bootstrap-icons/person-x-fill-aacd7a07.svg";